import { Card } from '@tempo-io/sui-card';
import { cn } from '@tempo-io/sui-class-utils';
import type { ComponentProps } from 'react';

export const TABLE_CARD_CHROME_CLASSNAME =
  'overflow-hidden rounded-md border border-border-neutral-subtle bg-bg-surface-raised shadow-xs';

export const TableCard = ({ className, ...props }: ComponentProps<typeof Card>) => (
  <Card className={cn(TABLE_CARD_CHROME_CLASSNAME, 'py-0', className)} {...props} />
);
